import {createContext} from 'react';

const PwaContext = createContext(null);

export default PwaContext;
